module.exports = __webpack_public_path__ + "img/score-3.fc551a53.png";